import { ProductSlug } from "@/api/product-api";

/**
 * 게임 상세 「지원 기기」에서 **그 게임에만** 번들 하나를 다른 제품으로 바꿔 보여 준다 — 게임 전용 번들 홍보용.
 *
 * ```
 *   exoshock   Starter Bundle: Camo → EXOSHOCK 번들   (작성자 지시 2026-11-03 · 「번들 있는 동안」)
 * ```
 *
 * **바꿔 넣을 제품이 판매 목록에 있을 때만** 바꾼다(`useValidBundles` 를 통과 — 통화 · 가격 · 게임 키 재고 · 한정판 품절,
 * `docs/bundle-region-policy.md`). 없으면(한국 · 키 소진 · 품절 · 판매 중지) 원래 번들이 그대로 남는다 — 그래서 행사가 끝나도
 * 이 표를 지우지 않아도 화면은 원래대로 돌아온다(정리할 때 지우면 된다).
 * 바꿀 대상이 그 나라 목록에 없으면 맨 뒤에 붙인다.
 */
export const GAME_SUPPORTED_DEVICE_SWAPS: Readonly<
  Record<string, readonly { replace: string; with: string }[]>
> = {
  exoshock: [
    {
      replace: ProductSlug.STARTER_BUNDLE_CAMO,
      with: ProductSlug.EXOSHOCK_BUNDLE,
    },
  ],
};
